import './verificationPage.scss';

import Box from '@mui/material/Box';
import { ThemeProvider } from '@mui/material/styles';
import { FormEvent, ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import heroDesigner from '../../../assets/hero-designer.svg';
import { Button } from '../../../components/Button/Button';
import { Header } from '../../../components/Header/Header';
import { NavigationPane } from '../../../components/NavigationPane/NavigationPane';
import useDashboardStore from '../../../store/dashboardStore/useDashboardStore';
import useThemeStore from '../../../store/themeStore/useThemeStore';
import { locator } from '../../../testing/e2e-locator/locator';

export function Component(): ReactNode {
  const { createTheme } = useThemeStore();
  const theme = createTheme();
  const navigate = useNavigate();

  const { t } = useTranslation();

  const {
    computed: { vehicleId },
  } = useDashboardStore();

  const formSubmit = (event: FormEvent): void => {
    event.preventDefault();

    navigate(`/verifications/${vehicleId}/document-list`);
  };

  return (
    <div className="verification-page">
      <ThemeProvider theme={theme}>
        <Box sx={theme.pageLayout}>
          <Header showDrawerToggle showLogo splitLayout />

          <main>
            <figure>
              <img alt={t('imageAlts.heroDesigner')} src={heroDesigner} />
            </figure>
            <form
              data-testid={locator.pages.verification.form.root}
              noValidate
              onSubmit={formSubmit}
            >
              <div className="form-content">
                <h1 data-testid={locator.pages.verification.form.h1}>
                  {t('VerificationPage.title')}
                </h1>
                <h2 data-testid={locator.pages.verification.form.h2}>
                  {t('VerificationPage.subtitle')}
                </h2>

                <div style={{ marginBottom: '3rem' }}>
                  <Button
                    data-testid={locator.pages.verification.form.submitButton}
                    fullWidth
                    submit
                  >
                    {t('VerificationPage.continue')}
                  </Button>
                </div>
              </div>
              <footer data-testid={locator.pages.verification.footer.root}>
                {t('copyright', { year: new Date().getFullYear() })}
              </footer>
            </form>
          </main>
        </Box>

        <NavigationPane withDrawer withUserNameHeader />
      </ThemeProvider>
    </div>
  );
}

Component.displayName = 'VerificationPage';
